import instance from '../axios';

export const getAll = async () => {
  const response = await instance.get(`returns`);
  return response.data;
};
export const getSource = async () => {
  const response = await instance.get(`returns/getSource`);
  return response.data;
};
export const insert = async (data) => {
  const response = await instance.post(`returns`, data);
  return response;
};
export const update = async (data) => {
  const response = await instance.put(`returns`, data);
  return response;
};
export const remove = async (id) => {
  const response = await instance.delete(`returns/` + id);
  return response;
};

export const transfer = async (data) => {
  const response = await instance.post(`returns/transfer`, data);
  return response;
};

export const passwordValidation = async (data) => {
  const response = await instance.post(`returns/password`, data);
  return response;
};
